import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function SerasaPage() {
  return (
    <MainLayout>
      <SEO 
        title="Consulta Serasa"
        description="Consulte informações no Serasa"
        keywords="serasa, consulta"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Consulta Serasa</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

